
























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { ListItem } from '@/models/Product';

@Component({
    components: {}
})
export default class FilterSorting extends Vue {
    protected sortItems!: ListItem[];
    protected showFilter: boolean = false;

    constructor() {
        super();
        this.sortItems = JSON.parse(this.$attrs['data-content']);
        this.$attrs['data-content'] = '';
    }

    private toggleFilter(e: any) {
        const filter = e.currentTarget;

        if (!filter.classList.contains('open')) {
            this.closeFilters();
            filter.classList.add('open');
        } else if (
            filter.classList.contains('open') &&
            e.srcElement.classList.contains('toggle-arrow')
        ) {
            this.closeFilters();
        }
    }

    private closeFilters() {
        const filters = document.querySelectorAll('.filter-item');
        filters.forEach((filter: any) => {
            filter.classList.remove('open');
        });
    }
}
